// extracted by mini-css-extract-plugin
export default {"cls1":"ResultsList-SecondaryResultTextContainer_cls1__P+G0T","cls2":"ResultsList-SecondaryResultTextContainer_cls2__BFhyq ResultsList-SecondaryResultTextContainer_cls1__P+G0T"};